export const businessInfo = {
  name: "Budimlija Elektro",
  phone: "063 1461 767",
  phoneClean: "0631461767",
  email: "milija.arsic@gmail.com",
  address: "Graditeljska 26, Beograd 11077",
  location: "Surčin / Beograd",
  social: {
    facebook: "https://www.facebook.com/jovan.arsic.5/?locale=sr_RS",
    instagram: "https://www.instagram.com/budimlija_elektro/",
  },
  mapsLink: "https://www.google.com/maps/search/?api=1&query=Graditeljska+26,+Beograd+11077",
};

export const navLinks = [
  { name: "Usluge", href: "#services" },
  { name: "O Nama", href: "#about" },
  { name: "Galerija", href: "#gallery" },
  { name: "Recenzije", href: "#testimonials" },
  { name: "Kontakt", href: "#contact" },
];

export const services = [
  {
    id: 1,
    title: "Semiranje elektro ormara",
    description: "Glavna usluga – profesionalno semiranje i montaža elektro tabli.",
    icon: "Cabinet",
  },
  {
    id: 2,
    title: "Električne instalacije",
    description: "Ugradnja, zamena i modernizacija svih elektro instalacija.",
    icon: "Plug",
  },
  {
    id: 3,
    title: "Sve vrste električarskih usluga",
    description: "Hitne intervencije, popravke, zamene, dijagnostika.",
    icon: "Wrench",
  },
  {
    id: 4,
    title: "Jake struje",
    description: "Industrijske i komercijalne instalacije, kablovi, trofazne mreže.",
    icon: "Zap",
  },
  {
    id: 5,
    title: "Slabe struje",
    description: "Internet, UTP kablovi, alarmi, zvona, interfoni.",
    icon: "Wifi",
  },
];

export const testimonials = [
  {
    id: 1,
    text: "Izuzetno precizan u radu i veoma profesionalan. Elektro ormar semiran savršeno!",
    author: "Goran L.",
    location: "Beograd",
    rating: 5,
  },
  {
    id: 2,
    text: "Brza i kvalitetna instalacija jake struje u radionici. Sve preporuke.",
    author: "Igor R.",
    location: "Surčin",
    rating: 5,
  },
  {
    id: 3,
    text: "Stručan majstor, sve objašnjeno i urađeno kako treba.",
    author: "Bojan S.",
    location: "Zemun",
    rating: 5,
  },
  {
    id: 4,
    text: "Galerija radova govori sve – kvalitet i profesionalizam.",
    author: "Marija N.",
    location: "Beograd",
    rating: 5,
  },
];
